{
  "version": 1,
  "source": "permissions-role-engine first-wave seed config",
  "eventsPolicy": "Events menu actions are allowed with endpointEvidenceStatus pending until backend endpoints are confirmed.",
  "actions": [
    {
      "action": "Admin.Access",
      "endpoints": [
        "v1/Authorization/Authentication/MyTenantDetails",
        "v1/Management/Selector",
        "v1/Management/GlobalProfile/GetGroupCodeList",
        "v1/Management/GlobalProfile/GetTenantProfileList",
        "v1/Management/GlobalProfile/GetTenantProfileListNoUsers",
        "v1/Management/Tenant/GetDetails",
        "v1/Management/TenantOsiSettings"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Admin.OsiAccess",
      "endpoints": [
        "v1/Authorization/Authentication/osiGroupHasTracker",
        "v1/Authorization/Authentication/osiProfileHasTracker",
        "v1/Authorization/Authentication/osiTenantAccess"
      ],
      "roleGroups": [
        "Osi Role",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TenantBranding.View",
      "endpoints": [
        "v1/Management/TenantLogo/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "MemberDefaultUser",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Dashboard.View",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant/GetLimitedTenantList",
        "v1/Management/TenantReport"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Dashboard.Header.Update",
      "endpoints": [
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.View",
      "endpoints": [
        "v1/Management/Profile",
        "v1/Management/Profile/GetTenantProfileDetail"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Create",
      "endpoints": [
        "v1/Management/Profile/CreateProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Update",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Authorization/Authentication/ProfileSuspendAccess",
        "v1/Management/Profile/UpdateProfile",
        "v1/Management/Profile/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Delete",
      "endpoints": [
        "v1/Management/Profile/DeleteProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Share",
      "endpoints": [
        "v1/Management/Profile/ShareProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.View",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.Create",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.Update",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.HolidayProgramme.View",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.ClassAttendance.View",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.CommitteeMeetings.View",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.View",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails",
        "v1/Management/Email/GetEmailTasklListAll",
        "v1/Management/Email/GetEmailTasklListAllFinalized",
        "v1/Management/Email/GetEmaillListByEmail",
        "v1/Management/Email/GetEmaillListByProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Create",
      "endpoints": [
        "v1/Management/Email/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Update",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Delete",
      "endpoints": [
        "v1/Management/Email/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Duplicate",
      "endpoints": [
        "v1/Management/Email/Dublicate",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Archive",
      "endpoints": [
        "v1/Management/Email/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Unarchive",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/Recover"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Send",
      "endpoints": [
        "v1/Management/Email/SendEmail",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Schedule",
      "endpoints": [
        "v1/Management/Email/SendEmail",
        "v1/Management/Email/GetEmailTasklListScheduledOnly",
        "v1/Management/Email/CancelEmailTask"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Drafts.View",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.History.View",
      "endpoints": [
        "v1/Management/Email/GetEmailTasklListNotScheduledOnly",
        "v1/Management/Email/GetEmailTasklListAllFinalized",
        "v1/Management/Email/GetEmailTasklDetail",
        "v1/Management/Email/GetEmailTaskCancelledListAll"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.View",
      "endpoints": [
        "v1/Management/EmailGroup",
        "v1/Management/EmailGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Create",
      "endpoints": [
        "v1/Management/EmailGroup/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Update",
      "endpoints": [
        "v1/Management/EmailGroup/Update",
        "v1/Management/EmailGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Delete",
      "endpoints": [
        "v1/Management/EmailGroup/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Recipients.Manage",
      "endpoints": [
        "v1/Management/EmailAssignee",
        "v1/Management/EmailAssignee/EmailAssigneeList",
        "v1/Management/EmailAssignee/Add",
        "v1/Management/EmailAssignee/Delete",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Attachments.Upload",
      "endpoints": [
        "v1/Management/EmailAttachment/Upload",
        "v1/Management/EmailAttachment/Download",
        "v1/Management/EmailAttachment/Delete",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Mobile.Create",
      "endpoints": [
        "v1/Management/Email/Add",
        "v1/Management/EmailSportType/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Mobile.Update",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/EmailSportType",
        "v1/Management/EmailSportType/Add",
        "v1/Management/EmailSportType/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateSettings.View",
      "endpoints": [
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateSettings.Update",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/LockSiteDesign"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateAccess.Manage",
      "endpoints": [
        "v1/Management/EmailTemplateAccess",
        "v1/Management/EmailTemplateAccess/Add",
        "v1/Management/EmailTemplateAccess/UpdateAccessLevel",
        "v1/Management/EmailTemplateAccess/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.SharedTemplates.Manage",
      "endpoints": [
        "v1/Management/EmailShared",
        "v1/Management/EmailShared/Add",
        "v1/Management/EmailShared/Delete",
        "v1/Management/EmailShared/GetMySharedTemplate",
        "v1/Management/EmailShared/LoadTemplateForTenant"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Osi.View",
      "endpoints": [
        "v1/Management/Email/osiGetEmails",
        "v1/Authorization/Authentication/osiTenantMailerMigrateStatus",
        "v1/Authorization/Authentication/osiGetTenantHeader",
        "v1/Authorization/Authentication/osiGetTenantLogo",
        "v1/Management/TenantOsiAccess"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Osi.Migrate",
      "endpoints": [
        "v1/Authorization/Authentication/osiTenantMailerMigrate",
        "v1/Authorization/Authentication/osiTenantMailerMigrateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.SystemEmails.View",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.View",
      "endpoints": [
        "v1/Management/Notification",
        "v1/Management/Notification/GetTenantNotification",
        "v1/Management/Notification/GetTenantNotificationDetail",
        "v1/Management/Notification/GetSenderNotificationList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Create",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Send",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Update",
      "endpoints": [
        "v1/Management/Notification/ReadTenantNotification",
        "v1/Management/Notification/ReadAllTenantNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Delete",
      "endpoints": [
        "v1/Management/Notification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.History.View",
      "endpoints": [
        "v1/Management/Notification/GetSenderNotificationList",
        "v1/Management/Notification/GetTenantNotificationDetail"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Setup.View",
      "endpoints": [
        "v1/Management/Notification/GetTenantNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Setup.Update",
      "endpoints": [
        "v1/Management/Notification/SetTenantNotificationQuestionnaireAnswer",
        "v1/Management/Notification/ReadAllTenantEventNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Recipients.Search",
      "endpoints": [
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Attachments.Upload",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.View",
      "endpoints": [
        "v1/Tracker/Tracker/GetDetails",
        "v1/Tracker/Tracker/GetTenantHubList",
        "v1/Tracker/Tracker/GetChildListByHubId",
        "v1/Tracker/Tracker/GetChildListByGroupId"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Update",
      "endpoints": [
        "v1/Tracker/Tracker/Update",
        "v1/Tracker/Tracker/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Export",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.View",
      "endpoints": [
        "v1/Tracker/Tracker/GetTenantHubList",
        "v1/Tracker/Tracker/GetChildListByHubId",
        "v1/Tracker/Tracker/GetChildListByGroupId",
        "v1/Tracker/Tracker/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Create",
      "endpoints": [
        "v1/Tracker/Tracker/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Update",
      "endpoints": [
        "v1/Tracker/Tracker/Update",
        "v1/Tracker/Tracker/UpdateGroupId",
        "v1/Tracker/Tracker/UpdateNextGroupId",
        "v1/Tracker/Tracker/GetDetails",
        "v1/Tracker/TrackerShared",
        "v1/Tracker/TrackerShared/Add",
        "v1/Tracker/TrackerShared/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Delete",
      "endpoints": [
        "v1/Tracker/Tracker/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Reorder",
      "endpoints": [
        "v1/Tracker/Tracker/UpdateViewOrder"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Categories.Manage",
      "endpoints": [
        "v1/Tracker/TrackerCategory",
        "v1/Tracker/TrackerCategory/Add",
        "v1/Tracker/TrackerCategory/Update",
        "v1/Tracker/TrackerCategory/Delete",
        "v1/Tracker/Tracker/AddTrackerCategory",
        "v1/Tracker/Tracker/RemoveTrackerSelectedCategory",
        "v1/Tracker/Tracker/GetTrackerSelectedCategory"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.SportTypes.Manage",
      "endpoints": [
        "v1/Tracker/TrackerSportType",
        "v1/Tracker/TrackerSportType/Add",
        "v1/Tracker/TrackerSportType/Remove",
        "v1/Master/SportType"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Ratings.Manage",
      "endpoints": [
        "v1/Tracker/TrackerRating",
        "v1/Tracker/TrackerRating/Add",
        "v1/Tracker/TrackerRating/Update",
        "v1/Tracker/TrackerRating/Delete",
        "v1/Tracker/TrackerRatingImage/UploadImage",
        "v1/Tracker/TrackerRatingImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Assignees.Manage",
      "endpoints": [
        "v1/Tracker/TrackerAssignee",
        "v1/Tracker/TrackerAssignee/TrackerAssigneeList",
        "v1/Tracker/TrackerAssignee/Add",
        "v1/Tracker/TrackerAssignee/AddPromoteTrackerProfile",
        "v1/Tracker/TrackerAssignee/RemovePromoteTrackerProfile",
        "v1/Tracker/TrackerAssignee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Promote.View",
      "endpoints": [
        "v1/Management/GlobalProfile/GetTenantGroupDetailWithSubGroup"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.View",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord",
        "v1/Tracker/TrackerAssigneeRecordAssessor"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Create",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Add",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Update",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Update",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Delete",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Delete",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.View",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.Export",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.Organization.View",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Certificates.View",
      "endpoints": [
        "v1/Tracker/TrackerImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Certificates.Update",
      "endpoints": [
        "v1/Tracker/TrackerImage/UploadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.View",
      "endpoints": [
        "v1/Management/TenantSite",
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/TenantSiteAccess/GetMyAccess",
        "v1/Authorization/Authentication/MyTenantDetails",
        "v1/Management/SiteTemplate",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Create",
      "endpoints": [
        "v1/Management/TenantSite/Add",
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Update",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Delete",
      "endpoints": [
        "v1/Management/TenantSite/Delete",
        "v1/Management/SiteTemplate/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Publish",
      "endpoints": [
        "v1/Management/SiteTemplate/ChangePublishStatus",
        "v1/Management/TenantSite/AddVersion",
        "v1/Management/SiteTemplate/AddVersion"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Settings.View",
      "endpoints": [
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Settings.Update",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Pages.Update",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/TenantSite/LockSiteDesign",
        "v1/Management/SiteTemplate/LockSiteDesign",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Sitemap.Update",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.View",
      "endpoints": [
        "v1/Management/TenantSiteAccess"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.Assign",
      "endpoints": [
        "v1/Management/TenantSiteAccess/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.Remove",
      "endpoints": [
        "v1/Management/TenantSiteAccess/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Versions.View",
      "endpoints": [
        "v1/Management/TenantSite/TenantSiteVersions"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Codes.View",
      "endpoints": [
        "v1/Management/TenantCode",
        "v1/Management/TenantCode/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Groups.View",
      "endpoints": [
        "v1/Management/TenantGroup",
        "v1/Management/TenantGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terms.View",
      "endpoints": [
        "v1/Management/TenantTerm",
        "v1/Management/TenantTerm/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermGroups.View",
      "endpoints": [
        "v1/Management/TenantTermGroup",
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.View",
      "endpoints": [
        "v1/Management/TenantMobile",
        "v1/Management/TenantMobile/GetDetails",
        "v1/Management/TenantMobile/TotalMobileUser"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Update",
      "endpoints": [
        "v1/Management/TenantMobile/Update",
        "v1/Management/TenantMobile/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Delete",
      "endpoints": [
        "v1/Management/TenantMobile/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.View",
      "endpoints": [
        "v1/Management/TenantMobile",
        "v1/Management/TenantMobile/GetDetails",
        "v1/Management/TenantMobileContact"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.Create",
      "endpoints": [
        "v1/Management/TenantMobile/Add",
        "v1/Management/TenantMobileContact/Add",
        "v1/Management/Mobile/UploadTenantProfileImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.Update",
      "endpoints": [
        "v1/Management/TenantMobile/Update",
        "v1/Management/TenantMobileContact/Update",
        "v1/Management/Mobile/UploadTenantProfileImage",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Contacts.Manage",
      "endpoints": [
        "v1/Management/TenantMobileContact",
        "v1/Management/TenantMobileContact/Add",
        "v1/Management/TenantMobileContact/Update",
        "v1/Management/TenantMobileContact/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Groups.View",
      "endpoints": [
        "v1/Management/MobileGroup/GetProfileGroups",
        "v1/Management/MobileGroup/GetProfileGroupsV2",
        "v1/Management/MobileGroup/GetProfileGroupsV2NoMobileConnection",
        "v1/Management/MobileGroup/GetGroupTerms",
        "v1/Management/MobileGroup/GetSelectedTermsGroup"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Groups.Update",
      "endpoints": [
        "v1/Management/MobileGroup/AddChatGroup",
        "v1/Management/MobileGroup/RemoveChatGroup",
        "v1/Management/MobileGroup/AddChatGroupMember",
        "v1/Management/MobileGroup/RemoveChatGroupMember",
        "v1/Management/TenantMobileGroup/Add",
        "v1/Management/TenantMobileGroup/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.GoLive",
      "endpoints": [
        "v1/Management/TenantMobile/UpdateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Status.Update",
      "endpoints": [
        "v1/Management/TenantMobile/UpdateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.UsersReport.View",
      "endpoints": [
        "v1/Management/MobileGroup/GetProfileGroupsV2NoMobileConnection"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.ChatReports.View",
      "endpoints": [
        "v1/Management/MobileChat/GetChatReports",
        "v1/Management/MobileChat/GetChatReportDetail",
        "v1/Management/MobileChat/GetHidedChatList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.ChatReports.Hide",
      "endpoints": [
        "v1/Management/MobileChat/HideChat"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.View",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail",
        "v1/Management/TenantRegistrationDefinition",
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantRegistrationStructureDetail",
        "v1/Management/TenantRegistrationTenantTerminology",
        "v1/Management/TenantRegistrationTenantComponent",
        "v1/Management/TenantRegistrationSportCategory",
        "v1/Management/TenantRegistrationProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.Main.View",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail",
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantRegistrationStructureDetail",
        "v1/Management/TenantRegistrationDefinition"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.Main.Update",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail/Update",
        "v1/Management/TenantRegistrationOrganisationDetail/Update",
        "v1/Management/TenantRegistrationStructureDetail/Update",
        "v1/Management/TenantRegistrationDefinition/Update",
        "v1/Management/TenantRegistrationTenantTerminology/Update",
        "v1/Management/TenantRegistrationTenantComponent/Update",
        "v1/Management/TenantRegistrationSportCategory/Update",
        "v1/Management/TenantRegistrationProfile/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.View",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Manage",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/Add",
        "v1/Authorization/Role/Update",
        "v1/Authorization/Role/Delete",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Create",
      "endpoints": [
        "v1/Authorization/Role/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Update",
      "endpoints": [
        "v1/Authorization/Role/Update",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Delete",
      "endpoints": [
        "v1/Authorization/Role/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.AssignEndpoint",
      "endpoints": [
        "v1/Authorization/RoleAPI",
        "v1/Authorization/RoleAPI/Add",
        "v1/Authorization/RoleAPI/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.AssignUser",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup",
        "v1/Authorization/ProfileRoleGroup/Add",
        "v1/Authorization/ProfileRoleGroup/Delete",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.View",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Create",
      "endpoints": [
        "v1/Authorization/RoleGroup/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Update",
      "endpoints": [
        "v1/Authorization/RoleGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Delete",
      "endpoints": [
        "v1/Authorization/RoleGroup/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.AssignRole",
      "endpoints": [
        "v1/Authorization/RoleGroupRole",
        "v1/Authorization/RoleGroupRole/Add",
        "v1/Authorization/RoleGroupRole/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileRoleGroups.Assign",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup",
        "v1/Authorization/ProfileRoleGroup/Add",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileRoleGroups.Delete",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup/Delete",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.View",
      "endpoints": [
        "v1/Master/DynamicField",
        "v1/Master/DynamicField/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Create",
      "endpoints": [
        "v1/Master/DynamicField/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Update",
      "endpoints": [
        "v1/Master/DynamicField/Update",
        "v1/Master/DynamicField/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Delete",
      "endpoints": [
        "v1/Master/DynamicField/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.ExtraData.Entry",
      "endpoints": [
        "v1/Master/DynamicFieldData/Entry",
        "v1/Master/DynamicFieldData/GetEntityData"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.ExtraData.BulkEntry",
      "endpoints": [
        "v1/Master/DynamicFieldData/BulkEntry",
        "v1/Master/DynamicFieldData/GetEntityGroupData"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.View",
      "endpoints": [
        "v1/Master/DynamicUISegment",
        "v1/Master/DynamicUISegment/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Create",
      "endpoints": [
        "v1/Master/DynamicUISegment/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Update",
      "endpoints": [
        "v1/Master/DynamicUISegment/Update",
        "v1/Master/DynamicUISegment/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Delete",
      "endpoints": [
        "v1/Master/DynamicUISegment/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.View",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock",
        "v1/Master/DynamicSegmentBlock/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Create",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Update",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Update",
        "v1/Master/DynamicSegmentBlock/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Delete",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.View",
      "endpoints": [
        "v1/Master/DynamicTemplate",
        "v1/Master/DynamicTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Create",
      "endpoints": [
        "v1/Master/DynamicTemplate/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Update",
      "endpoints": [
        "v1/Master/DynamicTemplate/Update",
        "v1/Master/DynamicTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Delete",
      "endpoints": [
        "v1/Master/DynamicTemplate/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.View",
      "endpoints": [
        "v1/Management/Membership",
        "v1/Management/Membership/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Create",
      "endpoints": [
        "v1/Management/Membership/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Update",
      "endpoints": [
        "v1/Management/Membership/Update",
        "v1/Management/Membership/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Delete",
      "endpoints": [
        "v1/Management/Membership/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.View",
      "endpoints": [
        "v1/Management/MembershipDetail",
        "v1/Management/MembershipDetail/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Create",
      "endpoints": [
        "v1/Management/MembershipDetail/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Update",
      "endpoints": [
        "v1/Management/MembershipDetail/Update",
        "v1/Management/MembershipDetail/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Delete",
      "endpoints": [
        "v1/Management/MembershipDetail/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.View",
      "endpoints": [
        "v1/Management/BaseFee",
        "v1/Management/BaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Create",
      "endpoints": [
        "v1/Management/BaseFee/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Update",
      "endpoints": [
        "v1/Management/BaseFee/Update",
        "v1/Management/BaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Delete",
      "endpoints": [
        "v1/Management/BaseFee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.View",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee",
        "v1/Management/MemberTypeBaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Create",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Update",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Update",
        "v1/Management/MemberTypeBaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Delete",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.View",
      "endpoints": [
        "v1/Management/MemberRegistration",
        "v1/Management/MemberRegistration/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.Create",
      "endpoints": [
        "v1/Management/MemberRegistration/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.Update",
      "endpoints": [
        "v1/Management/MemberRegistration/Update",
        "v1/Management/MemberRegistration/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.RoleGroups.View",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroupRole",
        "v1/Management/MemberRegistration/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.View",
      "endpoints": [
        "v1/Master/PersonType",
        "v1/Master/PersonType/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Create",
      "endpoints": [
        "v1/Master/PersonType/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Update",
      "endpoints": [
        "v1/Master/PersonType/Update",
        "v1/Master/PersonType/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Delete",
      "endpoints": [
        "v1/Master/PersonType/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.View",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline",
        "v1/Master/PersonTypeOrganisationDiscipline/GetDetails",
        "v1/Master/PersonTypeOrganisationDiscipline/TenantOrganisationDisciplineList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Create",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Update",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Update",
        "v1/Master/PersonTypeOrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Delete",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.View",
      "endpoints": [
        "v1/Master/MembershipCategory",
        "v1/Master/MembershipCategory/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Create",
      "endpoints": [
        "v1/Master/MembershipCategory/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Update",
      "endpoints": [
        "v1/Master/MembershipCategory/Update",
        "v1/Master/MembershipCategory/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Delete",
      "endpoints": [
        "v1/Master/MembershipCategory/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.View",
      "endpoints": [
        "v1/Master/OrganisationDiscipline",
        "v1/Master/OrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Create",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Update",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Update",
        "v1/Master/OrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Delete",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.View",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Create",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Update",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Update",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Delete",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.View",
      "endpoints": [
        "v1/Master/TAndC",
        "v1/Master/TAndC/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Create",
      "endpoints": [
        "v1/Master/TAndC/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Update",
      "endpoints": [
        "v1/Master/TAndC/Update",
        "v1/Master/TAndC/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Delete",
      "endpoints": [
        "v1/Master/TAndC/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.View",
      "endpoints": [
        "v1/Master/Terminology",
        "v1/Master/Terminology/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Create",
      "endpoints": [
        "v1/Master/Terminology/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Update",
      "endpoints": [
        "v1/Master/Terminology/Update",
        "v1/Master/Terminology/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Delete",
      "endpoints": [
        "v1/Master/Terminology/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.View",
      "endpoints": [
        "v1/Management/Tenant",
        "v1/Management/Tenant/GetDetails",
        "v1/Management/Tenant/GetLimitedTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Update",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Management/Tenant/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.FinalizeRegistration",
      "endpoints": [
        "v1/Management/TenantRegistrationFinalize/UpdateTenantRegistrationStatus"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ConvertToOrganization",
      "endpoints": [
        "v1/Authorization/Authentication/MakeTenantOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Impersonate",
      "endpoints": [
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Main.View",
      "endpoints": [
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantLogo/DownloadImage",
        "v1/Management/TenantAppLogo/DownloadImage",
        "v1/Management/TenantBackgroundImage/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Main.Update",
      "endpoints": [
        "v1/Management/Tenant/Update",
        "v1/Management/TenantRegistrationOrganisationDetail/Update",
        "v1/Management/TenantLogo/UploadImage",
        "v1/Management/TenantAppLogo/UploadImage",
        "v1/Management/TenantBackgroundImage/UploadImage",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Contact.View",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Contact.Update",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terminology.View",
      "endpoints": [
        "v1/Management/TenantRegistrationTenantTerminology"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terminology.Update",
      "endpoints": [
        "v1/Management/TenantRegistrationTenantTerminology/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.View",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Master/osiAccess",
        "v1/Management/TenantOsiAccess"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.Add",
      "endpoints": [
        "v1/Management/TenantOsiAccess/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.Remove",
      "endpoints": [
        "v1/Management/TenantOsiAccess/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.People.View",
      "endpoints": [
        "v1/Management/Profile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.View",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Master/SportType",
        "v1/Management/TenantSportType"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.Add",
      "endpoints": [
        "v1/Management/TenantSportType/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.Remove",
      "endpoints": [
        "v1/Management/TenantSportType/Remove"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Codes.View",
      "endpoints": [
        "v1/Management/TenantCode",
        "v1/Management/TenantCode/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Groups.View",
      "endpoints": [
        "v1/Management/TenantGroup",
        "v1/Management/TenantGroup/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terms.View",
      "endpoints": [
        "v1/Management/TenantTerm",
        "v1/Management/TenantTerm/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.TermGroups.View",
      "endpoints": [
        "v1/Management/TenantTermGroup",
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.TermGroups.Members.View",
      "endpoints": [
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.View",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.Add",
      "endpoints": [
        "v1/Authorization/Authentication/AddMemberToOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.Remove",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveMemberToOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Dashboard.View",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant",
        "v1/Management/Tenant/GetLimitedTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.View",
      "endpoints": [
        "v1/Management/Profile/GetAll",
        "v1/Management/Profile/GetTenantProfileDetail"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Update",
      "endpoints": [
        "v1/Management/Profile/GetTenantProfileDetail",
        "v1/Management/Profile/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.MakeSuperAdmin",
      "endpoints": [
        "v1/Authorization/Test/MakeUserSuperAdmin"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.View",
      "endpoints": [
        "v1/Authorization/Authentication/GetProfileTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.Assign",
      "endpoints": [
        "v1/Authorization/Authentication/AddTenantToProfile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.Remove",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveTenantFromProfile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdmin.Users.View",
      "endpoints": [
        "v1/Management/Profile/GetAllSuperAdminAndLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Create",
      "endpoints": [
        "v1/Management/Profile/AddProfileSuperAdminLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Update",
      "endpoints": [
        "v1/Management/Profile/UpdateProfileSuperAdminLimited",
        "v1/Management/Profile/MakeProfileToSuperAdminLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.View",
      "endpoints": [
        "v1/Management/Profile/GetProfileSuperAdminLimitedTenants"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Assign",
      "endpoints": [
        "v1/Management/Profile/AddProfileSuperAdminLimitedToTenant"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Update",
      "endpoints": [
        "v1/Management/Profile/UpdateProfileSuperAdminLimitedTenantRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Remove",
      "endpoints": [
        "v1/Management/Profile/RemoveProfileSuperAdminLimitedTenant"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.View",
      "endpoints": [
        "v1/Management/Profile/GetMyProfileDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.SocialConnect.View",
      "endpoints": [
        "v1/Management/Profile/GetMyProfileDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.SocialConnect.Update",
      "endpoints": [
        "v1/Authorization/Authentication/SocialConnect"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.Debug.View",
      "endpoints": [
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.ChangePassword",
      "endpoints": [
        "v1/Authorization/Authentication/UpdateMyPassword"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.View",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/GetDetails",
        "v1/Authorization/RoleAPI"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Create",
      "endpoints": [
        "v1/Authorization/Role/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Update",
      "endpoints": [
        "v1/Authorization/Role/GetDetails",
        "v1/Authorization/Role/Update"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Delete",
      "endpoints": [
        "v1/Authorization/Role/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.View",
      "endpoints": [
        "v1/Authorization/RoleAPI"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.Add",
      "endpoints": [
        "v1/Authorization/RoleAPI/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.Remove",
      "endpoints": [
        "v1/Authorization/RoleAPI/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Export",
      "endpoints": [
        "v1/Authorization/API",
        "v1/Authorization/Role",
        "v1/Authorization/RoleAPI",
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Import",
      "endpoints": [
        "v1/Authorization/Role/Add",
        "v1/Authorization/Role/Update",
        "v1/Authorization/RoleAPI/Add",
        "v1/Authorization/RoleGroup/Add",
        "v1/Authorization/RoleGroupRole/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.View",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroup/GetDetails",
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Create",
      "endpoints": [
        "v1/Authorization/RoleGroup/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Update",
      "endpoints": [
        "v1/Authorization/RoleGroup/GetDetails",
        "v1/Authorization/RoleGroup/Update"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Delete",
      "endpoints": [
        "v1/Authorization/RoleGroup/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.View",
      "endpoints": [
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.Add",
      "endpoints": [
        "v1/Authorization/RoleGroupRole/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.Remove",
      "endpoints": [
        "v1/Authorization/RoleGroupRole/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.View",
      "endpoints": [
        "v1/Master/Brand",
        "v1/Master/Brand/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Create",
      "endpoints": [
        "v1/Master/Brand/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Update",
      "endpoints": [
        "v1/Master/Brand/GetDetails",
        "v1/Master/Brand/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Delete",
      "endpoints": [
        "v1/Master/Brand/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Logo.Upload",
      "endpoints": [
        "v1/Master/BrandLogo/UploadImage",
        "v1/Master/BrandLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.View",
      "endpoints": [
        "v1/Master/Component",
        "v1/Master/Component/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Create",
      "endpoints": [
        "v1/Master/Component/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Update",
      "endpoints": [
        "v1/Master/Component/GetDetails",
        "v1/Master/Component/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Delete",
      "endpoints": [
        "v1/Master/Component/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Logo.Upload",
      "endpoints": [
        "v1/Master/ComponentLogo/UploadImage",
        "v1/Master/ComponentLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.View",
      "endpoints": [
        "v1/Master/ComponentBrand"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.Add",
      "endpoints": [
        "v1/Master/ComponentBrand/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.Delete",
      "endpoints": [
        "v1/Master/ComponentBrand/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.View",
      "endpoints": [
        "v1/Master/Country",
        "v1/Master/Country/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Create",
      "endpoints": [
        "v1/Master/Country/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Update",
      "endpoints": [
        "v1/Master/Country/GetDetails",
        "v1/Master/Country/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Delete",
      "endpoints": [
        "v1/Master/Country/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.View",
      "endpoints": [
        "v1/Master/SportCategory",
        "v1/Master/SportCategory/GetDetails",
        "v1/Master/TenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Create",
      "endpoints": [
        "v1/Master/SportCategory/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Update",
      "endpoints": [
        "v1/Master/SportCategory/GetDetails",
        "v1/Master/SportCategory/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Delete",
      "endpoints": [
        "v1/Master/SportCategory/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.View",
      "endpoints": [
        "v1/Master/TenantDefinition",
        "v1/Master/TenantDefinition/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Create",
      "endpoints": [
        "v1/Master/TenantDefinition/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Update",
      "endpoints": [
        "v1/Master/TenantDefinition/GetDetails",
        "v1/Master/TenantDefinition/Update",
        "v1/Master/Brand"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Delete",
      "endpoints": [
        "v1/Master/TenantDefinition/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Logo.Upload",
      "endpoints": [
        "v1/Master/TenantDefinitionLogo/UploadImage",
        "v1/Master/TenantDefinitionLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.View",
      "endpoints": [
        "v1/Master/Component",
        "v1/Master/ComponentTenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Add",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Update",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Delete",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.View",
      "endpoints": [
        "v1/Master/Terminology",
        "v1/Master/Terminology/GetDetails",
        "v1/Master/TenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Create",
      "endpoints": [
        "v1/Master/Terminology/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Update",
      "endpoints": [
        "v1/Master/Terminology/GetDetails",
        "v1/Master/Terminology/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Delete",
      "endpoints": [
        "v1/Master/Terminology/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.View",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Create",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Update",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/GetDetails",
        "v1/Master/ProfileOrganisationRole/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Delete",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.View",
      "endpoints": [
        "v1/Master/SportType",
        "v1/Master/SportType/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Create",
      "endpoints": [
        "v1/Master/SportType/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Update",
      "endpoints": [
        "v1/Master/SportType/GetDetails",
        "v1/Master/SportType/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Delete",
      "endpoints": [
        "v1/Master/SportType/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.View",
      "endpoints": [
        "v1/Master/osiAccess",
        "v1/Master/osiAccess/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Create",
      "endpoints": [
        "v1/Master/osiAccess/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Update",
      "endpoints": [
        "v1/Master/osiAccess/GetDetails",
        "v1/Master/osiAccess/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Delete",
      "endpoints": [
        "v1/Master/osiAccess/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.View",
      "endpoints": [
        "v1/Management/SiteTemplate",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Create",
      "endpoints": [
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Delete",
      "endpoints": [
        "v1/Management/SiteTemplate/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Duplicate",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Import",
      "endpoints": [
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Metadata.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Builder.View",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Builder.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Sitemap.View",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Sitemap.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.View",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Create",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Delete",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.PageBuilder.View",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.PageBuilder.Update",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.View",
      "endpoints": [
        "v1/Authorization/Authentication/MobileProfileList"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.Delete",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveMobileAccount"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.Impersonate",
      "endpoints": [
        "v1/Authorization/Authentication/MobileProfileList",
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileTenantList.View",
      "endpoints": [
        "v1/Authorization/Authentication/MobileTenantList"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileTenantList.Impersonate",
      "endpoints": [
        "v1/Authorization/Authentication/MobileTenantList",
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.Notifications.View",
      "endpoints": [
        "v1/Management/Notification"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.StartChatRecords.View",
      "endpoints": [
        "v1/Management/MobileChat/GetStartChatRecords"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.ChatRecords.View",
      "endpoints": [
        "v1/Management/MobileChat/GetChatRecords"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.ErrorLogs.View",
      "endpoints": [
        "v1/Authorization/Test/ErrorLogs"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.Audit.View",
      "endpoints": [
        "v1/Authorization/Test/AuditLogs"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.OASystem.Table",
      "endpoints": [
        "v1/Management/OASystems/Tables"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.OASystem.Detail",
      "endpoints": [
        "v1/Management/OASystems/Tables/{logicalName}",
        "v1/Management/OASystems/Tables/{logicalName}/Data"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    }
  ],
  "endpointCoverage": {
    "sourceEndpoints": [
      "v1/Authorization/API",
      "v1/Authorization/Authentication/AddMemberToOrg",
      "v1/Authorization/Authentication/AddTenantToProfile",
      "v1/Authorization/Authentication/ForgetMyPassword",
      "v1/Authorization/Authentication/GetMobileVersion",
      "v1/Authorization/Authentication/GetProfileTenantList",
      "v1/Authorization/Authentication/Login",
      "v1/Authorization/Authentication/Logout",
      "v1/Authorization/Authentication/MakeTenantOrg",
      "v1/Authorization/Authentication/MobileProfileList",
      "v1/Authorization/Authentication/MobileTenantList",
      "v1/Authorization/Authentication/MyDetails",
      "v1/Authorization/Authentication/NewTenant",
      "v1/Authorization/Authentication/Register",
      "v1/Authorization/Authentication/RemoveMemberToOrg",
      "v1/Authorization/Authentication/RemoveMobileAccount",
      "v1/Authorization/Authentication/RemoveTenantFromProfile",
      "v1/Authorization/Authentication/SocialConnect",
      "v1/Authorization/Authentication/SocialRegister",
      "v1/Authorization/Authentication/UpdateMobileVersion",
      "v1/Authorization/Authentication/UpdateMyPassword",
      "v1/Authorization/ProfileRoleGroup/GetDetails",
      "v1/Authorization/ProfileRoleGroup/Update",
      "v1/Authorization/RoleAPI/GetDetails",
      "v1/Authorization/RoleAPI/Update",
      "v1/Authorization/RoleGroup/Update",
      "v1/Authorization/RoleGroupRole/GetDetails",
      "v1/Authorization/RoleGroupRole/Update",
      "v1/Authorization/Test/AuditLogs",
      "v1/Authorization/Test/ErrorLogs",
      "v1/Authorization/Test/MakeUserSuperAdmin",
      "v1/Authorization/Test/RemoveRegistrationFinalizeFromProfile",
      "v1/Authorization/Test/RemoveUser",
      "v1/Authorization/Test/UserList",
      "v1/Management/GlobalProfile/GetTenantGroupList",
      "v1/Management/GlobalProfile/GetTenantProfileDetail",
      "v1/Management/Inventory",
      "v1/Management/Inventory/Add",
      "v1/Management/Inventory/Delete",
      "v1/Management/Inventory/GetDetails",
      "v1/Management/Inventory/Update",
      "v1/Management/InventoryImage/DownloadImage",
      "v1/Management/InventoryImage/UploadImage",
      "v1/Management/MemberRegistration/Delete",
      "v1/Management/MemberRegistration/Finalize",
      "v1/Management/MemberRegistration/ProfileMembership",
      "v1/Management/MemberRegistration/UpdateStatus",
      "v1/Management/MemberRegistrationCart",
      "v1/Management/MemberRegistrationCart/Add",
      "v1/Management/MemberRegistrationCart/Remove",
      "v1/Management/MobileChat/GetStartChatRecords",
      "v1/Management/OASystems/Tables",
      "v1/Management/OASystems/Tables/{logicalName}",
      "v1/Management/OASystems/Tables/{logicalName}/Data",
      "v1/Management/Profile/GetAll",
      "v1/Management/Profile/GetMyDetails",
      "v1/Management/Profile/GetMyProfileDetails",
      "v1/Management/Profile/GetMyProfiles",
      "v1/Management/Profile/UpdateMyProfileDetails",
      "v1/Management/SiteTemplate/SiteTemplateVersions",
      "v1/Management/Tenant",
      "v1/Management/Tenant/Add",
      "v1/Management/Tenant/Delete",
      "v1/Management/Tenant/GetDetails",
      "v1/Management/Tenant/Update",
      "v1/Management/TenantAppLogo/DownloadImage",
      "v1/Management/TenantAppLogo/UploadImage",
      "v1/Management/TenantBackgroundImage/DownloadImage",
      "v1/Management/TenantBackgroundImage/UploadImage",
      "v1/Management/TenantLogo/UploadImage",
      "v1/Management/TenantMobile/Recover",
      "v1/Management/TenantMobileGroup",
      "v1/Management/TenantOsiAccess/Add",
      "v1/Management/TenantOsiAccess/Delete",
      "v1/Management/TenantOsiAccess/GetDetails",
      "v1/Management/TenantOsiAccess/Update",
      "v1/Management/TenantRegistrationFinalize/UpdateProfileRegistrationStatus",
      "v1/Management/TenantRegistrationFinalize/UpdateTenantRegistrationStatus",
      "v1/Management/TenantSiteAccess/GetDetails",
      "v1/Management/TenantSiteAccess/Update",
      "v1/Management/TenantSportType",
      "v1/Management/TenantSportType/Add",
      "v1/Management/TenantSportType/Remove",
      "v1/Master/Brand",
      "v1/Master/Brand/Add",
      "v1/Master/Brand/Delete",
      "v1/Master/Brand/GetDetails",
      "v1/Master/Brand/Update",
      "v1/Master/BrandLogo/DownloadImage",
      "v1/Master/BrandLogo/UploadImage",
      "v1/Master/Component",
      "v1/Master/Component/Add",
      "v1/Master/Component/Delete",
      "v1/Master/Component/GetDetails",
      "v1/Master/Component/Update",
      "v1/Master/ComponentBrand",
      "v1/Master/ComponentBrand/Add",
      "v1/Master/ComponentBrand/Delete",
      "v1/Master/ComponentBrand/GetDetails",
      "v1/Master/ComponentBrand/Update",
      "v1/Master/ComponentLogo/DownloadImage",
      "v1/Master/ComponentLogo/UploadImage",
      "v1/Master/ComponentTenantDefinition",
      "v1/Master/ComponentTenantDefinition/Add",
      "v1/Master/ComponentTenantDefinition/Delete",
      "v1/Master/ComponentTenantDefinition/GetDetails",
      "v1/Master/ComponentTenantDefinition/Update",
      "v1/Master/Country",
      "v1/Master/Country/Add",
      "v1/Master/Country/Delete",
      "v1/Master/Country/GetDetails",
      "v1/Master/Country/Update",
      "v1/Master/DynamicSegmentBlock/GetDetailsByIdentity",
      "v1/Master/DynamicTemplate/GetDetailsByIdentity",
      "v1/Master/DynamicUISegment/GetDetailsByIdentity",
      "v1/Master/osiAccess",
      "v1/Master/osiAccess/Add",
      "v1/Master/osiAccess/Delete",
      "v1/Master/osiAccess/GetDetails",
      "v1/Master/osiAccess/Update",
      "v1/Master/PersonTypeOrganisationDiscipline/GetOrganisationTenants",
      "v1/Master/SportCategory",
      "v1/Master/SportCategory/Add",
      "v1/Master/SportCategory/Delete",
      "v1/Master/SportCategory/GetDetails",
      "v1/Master/SportCategory/Update",
      "v1/Master/SportType",
      "v1/Master/SportType/Add",
      "v1/Master/SportType/Delete",
      "v1/Master/SportType/GetDetails",
      "v1/Master/SportType/Update",
      "v1/Master/TenantDefinition",
      "v1/Master/TenantDefinition/Add",
      "v1/Master/TenantDefinition/Delete",
      "v1/Master/TenantDefinition/GetDetails",
      "v1/Master/TenantDefinition/Update",
      "v1/Master/TenantDefinitionLogo/DownloadImage",
      "v1/Master/TenantDefinitionLogo/UploadImage",
      "v1/Public/Tenant/ContactUs",
      "v1/Public/Tenant/Details",
      "v1/Public/Tenant/DownloadBackgroundImage",
      "v1/Public/Tenant/DownloadLogo",
      "v1/Tracker/Tracker",
      "v1/Tracker/TrackerAssignee/GetDetails",
      "v1/Tracker/TrackerAssignee/Update",
      "v1/Tracker/TrackerAssigneeRecord/GetDetails",
      "v1/Tracker/TrackerAssigneeRecordAssessor/GetDetails",
      "v1/Tracker/TrackerCategory/GetDetails",
      "v1/Tracker/TrackerRating/GetDetails",
      "v1/Tracker/TrackerShared/GetDetails",
      "v1/Tracker/TrackerShared/Update"
    ]
  }
}
